import { EErrorType, EErrorScope, EErrorBlock, EErrorSeverity } from '@/helpers/enums';
import { hideModal } from '@/helpers/errors';

import i18n from '@/plugins/i18n';

export const errorsByBroker = {
  // Brokers
  koin: {
    // Codes
    1002: {
      code: 1002,
      type: EErrorType.payment,
      scope: EErrorScope.payment,
      block: EErrorBlock.none,
      severity: EErrorSeverity.warning,
      isOtherPaymentMethodsEnabled: false,
      informative: {
        image: 'error-security-koin.png',
        title: i18n.t('App.Checkout.payment.error.title'),
        message:
          `<strong>Atenção!</strong> O parcelamento do seu boleto foi negado por motivos de segurança.
          Por favor, entre em contato com a Koin ou tente outro método de pagamento para realizar sua compra.
          Se preferir, entre em contato com nossa equipe de atendimento em um dos
          <a href="https://www.empiricus.com.br/faq/" target="_blank">Canais de Atendimento.</a>`,
        buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
        buttonAction: (code: number | string) => hideModal(code),
      },
    }
  },
};
